// LEGAL STATUS: To be legally validated before commercial production (EN translation of fr/TermsPage.js).
import { Link } from "react-router-dom";
import { Page, H1, H2, Lead, P, UL, Notice, Toc, DocVersion } from "../../public/primitives";
import { legal } from "../../../config/legal";

export const TermsPage = () => (
  <Page testid="terms-page">
    <H1>Terms of use</H1>
    <Lead>Version <DocVersion value={legal.termsVersion} /> — last updated {legal.lastUpdated}.</Lead>

    <Toc
      items={[
        { id: "objet", label: "Purpose" },
        { id: "acces", label: "Access" },
        { id: "usage-sans-compte", label: "Use without an account" },
        { id: "compte", label: "Account" },
        { id: "obligations", label: "Obligations" },
        { id: "protection-liens", label: "Link protection" },
        { id: "usages-interdits", label: "Prohibited uses" },
        { id: "disponibilite", label: "Availability" },
        { id: "evolution", label: "Changes" },
        { id: "suspension", label: "Suspension" },
        { id: "propriete", label: "Intellectual property" },
        { id: "responsabilite", label: "Liability" },
        { id: "donnees", label: "Personal data" },
        { id: "droit-applicable", label: "Governing law" },
      ]}
    />

    <H2 id="objet">Purpose</H2>
    <P>
      These terms govern the use of SecurePass, a service for creating secure, temporary links to send or
      receive sensitive information.
    </P>

    <H2 id="acces">Access to the service</H2>
    <P>The service is available online, without installation, via a recent browser.</P>

    <H2 id="usage-sans-compte">Use without an account</H2>
    <P>
      Occasional use is possible without an account (limited durations, no history, anti-abuse limits).
      See the <Link to="/documentation" className="text-emerald-600 underline">Help Center</Link>.
    </P>

    <H2 id="compte">Creating an account</H2>
    <P>Creating an account gives access to history, workspaces and advanced options.</P>

    <H2 id="obligations">User obligations</H2>
    <UL>
      <li>Provide accurate information when creating an account.</li>
      <li>Keep their credentials confidential.</li>
      <li>Use the service in accordance with the law and these terms.</li>
    </UL>

    <H2 id="protection-liens">Protection and transmission of links</H2>
    <P>
      The user is responsible for the links they generate and for the recipients to whom they send them.
      Anyone with the full link can access the information while it is available.
    </P>

    <H2 id="usages-interdits">Prohibited uses</H2>
    <UL>
      <li>Unlawful activities or activities infringing the rights of third parties.</li>
      <li>Attempts to circumvent security or anti-abuse measures.</li>
      <li>Use that harms the proper operation of the service.</li>
    </UL>

    <H2 id="disponibilite">Availability</H2>
    <P>The service is provided within reasonable limits, without any guarantee of continuous availability.</P>

    <H2 id="evolution">Changes to the service</H2>
    <P>Features may change, be added or be removed.</P>

    <H2 id="suspension">Suspension in case of abuse</H2>
    <P>Abusive use may lead to access being limited or suspended.</P>

    <H2 id="propriete">Intellectual property</H2>
    <P>The elements of the service are protected and reserved to {legal.publisherName}.</P>

    <H2 id="responsabilite">Liability</H2>
    <P>
      The liability of {legal.publisherName} is assessed within the limits provided by applicable law. The
      user remains responsible for the content they share and for their recipients.
    </P>

    <H2 id="donnees">Personal data</H2>
    <P>
      Data processing is described in the
      <Link to="/confidentialite" className="text-emerald-600 underline"> privacy policy</Link>.
    </P>

    <H2 id="droit-applicable">Governing law</H2>
    <P>The governing law and competent jurisdiction will be specified in the final version.</P>

    <Notice testid="terms-work-note">
      Working version to be legally validated before commercial production.
    </Notice>
  </Page>
);

export default TermsPage;
